import React from "react";
import Grid from "@mui/material/Grid";
import Button from "@limitless/modern/inputs/button/Button";
import MultilineTextField from "@limitless/modern/inputs/multiline-text-field/MultilineTextField";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useExpertSupportMessageCreationContext } from "@limitless/expert";

const RespondAnnouncement = () => {
    const {
        handleAnnouncementMessage,
        queryDetails,
        error,
        announcementRouteState,
        announcementBody,
        handleSubmitAnnouncementMessage,
        isSubmitting
    } = useExpertSupportMessageCreationContext();

    return (
        <>
            <Typography variant="h6">{"Re: Announcement"}</Typography>
            <Typography variant="body2" weight="400" component="div" style={{ marginTop: "12px", display: "inline" }}>
                {announcementRouteState.body || ""}
            </Typography>

            <Grid style={{ marginTop: "14px", marginBottom: "28px" }}>
                <MultilineTextField
                    label="Please provide more details below"
                    name="Please provide more details below"
                    value={queryDetails}
                    onChange={handleAnnouncementMessage}
                    required
                    style={{ width: "435px", height: "109px" }}
                    placeholder="Type here..."
                    fullWidth
                    multiline
                    errorText={"Must be at least 10 characters"}
                    error={error}
                    helperText={error ? "Must be at least 10 characters" : ""}
                    rows={5}
                />
            </Grid>
            <Button
                size="small"
                variant="contained"
                disabled={announcementBody === "" || error || isSubmitting}
                onClick={handleSubmitAnnouncementMessage}
            >
                {isSubmitting ? "SUBMITTING..." : "SUBMIT"}
            </Button>
        </>
    );
};

export default RespondAnnouncement;
